//open freshchat at click on specific link
document.addEventListener("DOMContentLoaded", function() {
    const freshChatLink = document.querySelector('.footer-link-kontakt');
    freshChatLink && freshChatLink.addEventListener('click', function(e) {
        e.preventDefault();
        window.fcWidget.open();
    });

});


